import { createCRUDHook } from './createCRUDHook';
import { DraftPartMultiplierDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DraftPartMultiplierDto>({
    entityName: 'DraftPartMultiplier',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  });

export const DraftPartMultiplierContext = Context;
export const useDraftPartMultiplierManager = useManager;
export const useDraftPartMultiplier = useConsumer;
